import { useCallback, useEffect, useRef } from "react";
import Excalidraw from "@ralphefficespace/board";
import {
  deleteBoard,
  initialiseBoard,
  loadImages,
  onChangeBoard,
  onLibraryChange,
  resolvablePromise,
  setBoardAPI,
  toggleOthersCanEdit,
} from "space/spaceBoard";
import { PINNED_SHARE } from "slices/spaceMediaSlice";
import {
  sendStopBoard,
  sendTeaseBoard,
} from "slices/channels/spaceChannelSlice";
import {
  selectCloseBoard,
  selectDownloadBoard,
  setCloseBoard,
  setDownloadBoard,
  turnOffShare,
} from "slices/spaceSlice";
import Modal from "components/HOCS/Modal";
import BoardDownloadModal from "./BoardDownloadModal/BoardDownloadModal";
import BoardImage from "./BoardImage/BoardImage";
import StopBoardModal from "./StopBoardModal/StopBoardModal";
import { useDispatch, useSelector } from "react-redux";

const Board = ({ luid, person, local = false }) => {
  // const [Comp, setComp] = useState(null);
  const { given_name, visual } = person;

  const initialStatePromiseRef = useRef({ promise: resolvablePromise() });
  const live = useRef(true);
  const dispatch = useDispatch();
  const downloadBoard = useSelector(selectDownloadBoard);
  const closeBoard = useSelector(selectCloseBoard);

  // useEffect(() => {
  //   import("@excalidraw/excalidraw").then((comp) => setComp(comp.default));
  // }, []);

  useEffect(() => {
    return () => {
      sendStopBoard(luid);
      deleteBoard(luid);
    };
  }, [luid]);

  useEffect(() => {
    if (visual === PINNED_SHARE || local) {
      initialiseBoard(luid).then((data) => {
        console.log("initialiseBoard DOT THEN ACTIVATED: " + luid);
        live.current = true;
        loadImages(data);
        initialStatePromiseRef.current.promise.resolve(data.scene);
      });
    } else {
      deleteBoard(luid);
      initialStatePromiseRef.current = { promise: resolvablePromise() };
      if (live.current) {
        live.current = false;
        sendTeaseBoard(luid);
      }
    }
  }, [local, luid, visual]);

  const renderTopRightUI = useCallback((isMobile, appState) => {
    return (
      <div>
        <div className={`board-top-right`}></div>
      </div>
    );
  }, []);

  // const renderFooter = useCallback(
  //   (isMobile) => {
  //     // if (isMobile) return;
  //     // else
  //     return (
  //       <div className={`media-info`}>
  //         <div className={`default-options ${local ? "close" : ""}`}>
  //           <div className={`name `}>
  //             <div>{given_name}</div>
  //             <div>{family_name}</div>
  //           </div>
  //           {!local && (
  //             <button
  //               className="muting"
  //               onClick={() =>
  //                 mutedForMe ? unmuteForMe(luid) : muteForMe(luid)
  //               }
  //             >
  //               <span>
  //                 {mutedForMe ? (
  //                   <VideoBarPersonMutedForMe />
  //                 ) : (
  //                   <VideoBarPersonUnMutedForMe />
  //                 )}
  //               </span>
  //             </button>
  //           )}
  //           <div className="video-bar-avatar">
  //             <Avatar
  //               avatar_key={avatar_key}
  //               given_name={given_name}
  //               family_name={family_name}
  //             />
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   },
  //   [luid, mutedForMe, avatar_key, given_name, family_name, local]
  // );

  return (
    <>
      {(visual === PINNED_SHARE || local) && (
        <>
          {/* {Comp && <Comp />} */}
          <Excalidraw
            ref={(api) => setBoardAPI(luid, api)}
            onChange={(...args) => onChangeBoard(luid, ...args)}
            UIOptions={{
              canvasActions: { saveAsImage: false, export: false },
            }}
            initialData={initialStatePromiseRef.current.promise}
            renderTopRightUI={renderTopRightUI}
            // renderFooter={renderFooter}
            onCollabButtonClick={() => toggleOthersCanEdit(luid)}
            onDownloadButtonClick={() => {
              dispatch(setDownloadBoard(luid));
            }}
            // langCode={langCode}
            detectScroll={false}
            handleKeyboardGlobally={true}
            onLibraryChange={onLibraryChange}
            autoFocus={true}
          />
          {downloadBoard === luid && (
            <Modal
              growth={false}
              noBackDropClick={false}
              lightBackDrop={false}
              header={`Save ${given_name}'s Whiteboard As...`}
              content={
                <BoardDownloadModal
                  luid={luid}
                  onClose={() => dispatch(setDownloadBoard(null))}
                />
              }
              onDismiss={() => dispatch(setDownloadBoard(null))}
            />
          )}
          {closeBoard === luid && (
            <Modal
              growth={false}
              noBackDropClick={false}
              lightBackDrop={false}
              header={`Stop Sharing Whiteboard?`}
              content={
                <StopBoardModal
                  onDismiss={() => dispatch(setCloseBoard(null))}
                  onSave={() => {
                    dispatch(setCloseBoard(null));
                    dispatch(setDownloadBoard(luid));
                  }}
                  onStop={() => {
                    dispatch(setCloseBoard(null));
                    turnOffShare();
                  }}
                />
              }
              onDismiss={() => dispatch(setCloseBoard(null))}
            />
          )}
        </>
      )}
      <BoardImage
        luid={luid}
        given_name={given_name}
        shown={!(visual === PINNED_SHARE || local)}
      />
    </>
  );
};

export default Board;
